import axios from 'axios'; // Ensure axios is installed and imported
import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import '../assets/css/PollView.css';
import { baseurl } from '../utility/helper';
const EditChapter = () => {
  const location = useLocation();
  const { chapterId, edit } = location.state || {};
  const [isEditing, setIsEditing] = useState(edit);
  const [formData, setFormData] = useState({
    chapter: '',
    chapter_name: '',
    chapter_desc: '', // Ensure this is initialized
    chapter_status: '',
    chapter_email: '', // Ensure this is initialized
    chapter_president: '', // Ensure this is initialized
    chapter_chairman: '', // Ensure this is initialized
    register_end_date: '', // Ensure this is initialized
    president_mobile: ''
  });
  
  const fetchChapterData = () => {
    if (chapterId) {
      axios.get(`${baseurl}/admin/chapters/${chapterId}`)
        .then(response => {
          setFormData(response.data);
          console.log('Updated data:', response.data);
        })
        .catch(error => {
          console.error('Error fetching chapter data:', error);
        });
    }
  };
  
  // Call fetchChapterData inside useEffect
  useEffect(() => {
    fetchChapterData();
  }, [chapterId]);
  
  const handleEditMode = () => {
    setIsEditing(true);
  };

  const handleClose = () => {
    setIsEditing(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = () => {
    axios.put(`${baseurl}/admin/chapters/${chapterId}`, formData)
      .then(response => {
        console.log('Data saved:', response.data);
        setIsEditing(false);
        fetchChapterData(); // Refetch data after saving
      })
      .catch(error => {
        console.error('Error saving data:', error);
      });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    axios.put(`${baseurl}/admin/chapters/${chapterId}`, formData)
      .then(response => {
        console.log('Data saved:', response.data);
        setIsEditing(false);
        fetchChapterData(); // Refetch data after saving
      })
      .catch(error => {
        console.error('Error saving data:', error);
      });
  };
  
  
  return (
    <div className="">
      <div className="container mt-4">
        <div className="col-md-12 text-end row">
          <div className='col-md-6' style={{ textAlign : 'left'}}>
          <button className="cl-back-btn " onClick={() => window.history.back()}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
            Back
          </button>
          </div>
          <div className='col-md-6'>
          {!isEditing && <button className="btn btn-primary" onClick={handleEditMode}>Edit</button>}
          &nbsp;
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="profile-section" style={{ marginTop: '20px' }}>
            <center><h3><b>View Chapter</b></h3></center>

            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="title">Chapter Name:</label>
                  <input
                    type="text"
                    id="chapter_name"
                    name="chapter_name"
                    className="form-control"
                    value={formData.chapter_name}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="description">Chapter Description:</label>
                  <textarea
                    id="chapter_desc"
                    className="form-control"
                    name="chapter_desc"
                    value={formData.chapter_desc}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                </div>
                <div className="col-md-6"  style={{ paddingTop: '20px' }}>
                  <label htmlFor="chapter_status">Status</label>
                  <select
                    className="form-select form-control"
                    name="chapter_status"
                    value={formData.chapter_status}
                    onChange={handleChange}
                    disabled={!isEditing}
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                 
                </div>

                <div className="col-md-6" style={{ paddingTop: '20px' }}>
                  <label htmlFor="startTime">Email:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="chapter_email"
                    name="chapter_email"
                    value={formData.chapter_email}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                </div>
                <div className="col-md-6" style={{ paddingTop: '20px' }}>
                  <label htmlFor="endTime">Chapter President:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="chapter_president"
                    name="chapter_president"
                    value={formData.chapter_president}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                </div>
                {/* <div className="col-md-6" style={{ paddingTop: '20px' }}>
                  <label htmlFor="regStartDateTime">Chapter Chairman:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="chapter_chairman"
                    name="chapter_chairman"
                    value={formData.chapter_chairman}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                </div> */}
                <div className="col-md-6" style={{ paddingTop: '20px' }}>
                  <label htmlFor="regEndDateTime">President No:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="president_mobile"
                    name="president_mobile"
                    value={formData.president_mobile}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                </div>

              </div>
            </div>
          </div>
          {isEditing && (
            <div className="text-center" style={{ marginTop: '20px' }}>
              <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancel</button> &nbsp;
              <button type="submit" className="btn btn-primary">Save</button>
            </div>
          )}
        </form>
      </div>
      
    </div>
  );
};

export default EditChapter;
